export const EstraiDatiBase=[
  '',
  `{
    EstraiSessoBeneficiario{
      cdDominioTcb
      tlValoreTestuale
    }
    EstraiEtaLavoratore{
      cdDominioTcb
      tlValoreTestuale
    }
    EstraiCarattereLavoratore{
      cdDominioTcb
      tlValoreTestuale
    }
    EstraiTitoloStudioLavoratore{
      cdDominioTcb
      tlValoreTestuale
    }
    EstraiCorsiTata{
      cdDominioTcb
      tlValoreTestuale
    }
    EstraiLingueParlate{
      cdDominioTcb
      tlValoreTestuale
    }
  }`
]

export const EstraiSessoBeneficiario = () => [
  'EstraiSessoBeneficiario',
  `{
    EstraiSessoBeneficiario{
      cdDominioTcb
      tlValoreTestuale
    }
    
  }`,
];

export const EstraiEtaLavoratore = () => [
  'EstraiEtaLavoratore',
  `{
    EstraiEtaLavoratore{
      cdDominioTcb
      tlValoreTestuale
    }
  }`,
];

export const EstraiEsperienzePregresse = () => [
  'EstraiEsperienzePregresse',
  `{
    EstraiEsperienzePregresse{
      cdDominioTcb
      tlValoreTestuale
    }
  }`,
];

export const EstraiCarattereLavoratore = () => [
  'EstraiCarattereLavoratore',
  `{
    EstraiCarattereLavoratore{
      cdDominioTcb
      tlValoreTestuale
    }
  }`,
];

export const EstraiTitoloStudioLavoratore = () => [
  'EstraiTitoloStudioLavoratore',
  `{
    EstraiTitoloStudioLavoratore{
      cdDominioTcb
      tlValoreTestuale
    }
  }`,
];

export const EstraiCorsiTata = () => [
  'EstraiCorsiTata',
  `{
    EstraiCorsiTata{
      cdDominioTcb
      tlValoreTestuale
    }
  }`,
];

export const EstraiLingueParlate = () => [
  'EstraiLingueParlate',
  `{
    EstraiLingueParlate{
      cdDominioTcb
      tlValoreTestuale
    }
  }`,
];
